import { Stack } from '@cp/ds/src/components/stack';
import { useRef } from 'react';
import { ToastActions, ToastStore } from './appToastManager';
import { ToastSteps } from './toastSteps';
import { ToastItem } from './toastItem';
import { useToastManager } from './useToastManager';
import { IToastItem } from './types';
import { BOTTOM_CENTER_PROPS, BOTTOM_LEFT_PROPS, BOTTOM_RIGHT_PROPS, TOP_CENTER_PROPS, TOP_LEFT_PROPS, TOP_RIGHT_PROPS } from './config';
import { TOAST_POSITIONS } from './const';

interface ListsOfToastsProps {
  store: ToastStore;
  dispatch: (action: ToastActions) => void;
}

const overloadDelay = 100;

export const ListsOfToasts = ({ dispatch, store }: ListsOfToastsProps) => {
  const overload = useRef(false);
  const manager = useToastManager();

  const openedHandler = (eventToast: IToastItem) => {
    let endAt = Date.now() + eventToast.duration;
    const timer = () => {
      if (overload.current) {
        endAt += overloadDelay;
        setTimeout(timer, overloadDelay);
        return;
      }
      if (Date.now() >= endAt) {
        manager.close(eventToast.id);
        return;
      }
      setTimeout(timer, overloadDelay);
    };
    timer();
  };

  const renderItems = (toast: IToastItem) => (
    <ToastSteps
      key={toast.id}
      onDelete={(toastId) => {
        dispatch({ type: 'delete', id: toastId });
      }}
      onMouseLeave={() => {
        overload.current = false;
      }}
      onMouseOver={() => {
        overload.current = true;
      }}
      onOpened={openedHandler}
      toast={toast}
    >
      <ToastItem toast={toast} />
    </ToastSteps>
  );

  return (
    <>
      <Stack {...TOP_LEFT_PROPS}>{store[TOAST_POSITIONS.TOP_LEFT].map(renderItems)}</Stack>
      <Stack {...TOP_CENTER_PROPS}>{store[TOAST_POSITIONS.TOP_CENTER].map(renderItems)}</Stack>
      <Stack {...TOP_RIGHT_PROPS}>{store[TOAST_POSITIONS.TOP_RIGHT].map(renderItems)}</Stack>
      <Stack {...BOTTOM_LEFT_PROPS}>{store[TOAST_POSITIONS.BOTTOM_LEFT].map(renderItems)}</Stack>
      <Stack {...BOTTOM_CENTER_PROPS}>{store[TOAST_POSITIONS.BOTTOM_CENTER].map(renderItems)}</Stack>
      <Stack {...BOTTOM_RIGHT_PROPS}>{store[TOAST_POSITIONS.BOTTOM_RIGHT].map(renderItems)}</Stack>
    </>
  );
};
